import DOMPurify from 'dompurify';

export const sanitizedData = (data) => ({
   __html: DOMPurify.sanitize(data, { ADD_ATTR: ['target'] })
})
